module.exports = __webpack_public_path__ + "img/educPlus-min.41549057.png";